// directives/inputmask.js
import Inputmask from 'inputmask'

export default {
	mounted(el, binding) {
		// Применяем маску
		Inputmask(binding.value).mask(el)
	},
	unmounted(el) {
		// Сброс (по желанию)
		Inputmask.remove(el)
	},
}
